import { Link } from 'react-router-dom'
import { FiAlertTriangle, FiAlertCircle, FiInfo, FiGift, FiCheckCircle } from 'react-icons/fi'
import './NotificationGroups.css'

const SEVERITY_ICON = {
    critical: FiAlertTriangle,
    warning: FiAlertCircle,
    info: FiInfo,
    party: FiGift,
}

function NotificationGroups({ groups, emptyMessage = 'Nenhum aviso no momento' }) {

    if (!groups || groups.length === 0) {
        return (
            <div className="notif-empty">
                <FiCheckCircle size={26} className="notif-empty-icon" />
                <p>{emptyMessage}</p>
            </div>
        )
    }

    return (
        <div className="notif-group-list">
            {groups.map((group) => {
                const Icon = SEVERITY_ICON[group.severity] || FiInfo
                const content = (
                    <>
                        <div className={`notif-group-icon notif-group-icon-${group.severity}`}>
                            <Icon size={22} />
                        </div>
                        <div className="notif-group-text">{group.text}</div>
                    </>
                )
                return group.link ? (
                    <Link key={group.key} to={group.link} className="notif-group" reloadDocument>
                        {content}
                    </Link>
                ) : (
                    <div key={group.key} className="notif-group notif-group-static">
                        {content}
                    </div>
                )
            })}
        </div>
    )
}

export default NotificationGroups
